var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('PermissiveBtn', _vm._g(_vm._b({
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "size": "xs",
      "variant": "danger",
      "title": "Apagar Entrada",
      "titleBlocked": "Sem permissão para apagar",
      "can": _vm.can,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, 'PermissiveBtn', Object.assign({}, _vm.$props, _vm.$attrs), false), _vm.$listeners), [_vm._v(" Apagar ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }